<div class="messages" #list (scroll)="onScroll()" role="log" aria-live="polite" aria-label="Meeting chat messages">
  <div class="empty" *ngIf="!messages.length">
    <span class="empty-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" focusable="false">
        <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
      </svg>
    </span>
    <p>No messages yet</p>
    <!-- True to the room: chat goes out as a Chime data message with a 5-minute lifetime (CHAT_LIFETIME_MS), which Chime replays to anyone who joins within it. -->
    <span class="empty-text">Messages are shown to everyone in the meeting. People who join later see the last 5 minutes.</span>
  </div>

  <div
    class="message"
    *ngFor="let message of messages; let i = index; trackBy: trackMessage"
    [class.mine]="message.local"
    [class.grouped]="!startsGroup(i)">
    <span
      class="avatar"
      *ngIf="!message.local && startsGroup(i)"
      [style.background]="avatar(message).background"
      [style.color]="avatar(message).color"
      aria-hidden="true">{{ initials(message) }}</span>
    <div class="body">
      <div class="meta" *ngIf="startsGroup(i)">
        <span class="sender" *ngIf="!message.local">{{ message.sender }}</span>
        <time>{{ clock(message.at) }}</time>
      </div>
      <div class="bubble">{{ message.text }}</div>
    </div>
  </div>
</div>

<form class="compose" [class.disabled]="disabled" (ngSubmit)="submit()">
  <textarea
    #box
    name="draft"
    rows="1"
    [(ngModel)]="draft"
    [disabled]="disabled"
    (keydown)="onKeydown($event)"
    placeholder="Type a message"
    aria-label="Type a message"></textarea>
  <span class="count" [class.over]="draft.length > maxChars" *ngIf="draft.length > maxChars * 0.8" aria-live="polite">
    {{ draft.length }}/{{ maxChars }}
  </span>
  <button
    type="submit"
    class="send"
    [class.blocked]="disabled || draft.length > maxChars"
    [disabled]="!canSend"
    aria-label="Send"
    matTooltip="Send (Enter)">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
      <path d="m22 2-7 20-4-9-9-4Z" />
      <path d="M22 2 11 13" />
    </svg>
  </button>
</form>
